import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.985 9.985a2.85 2.85 0 1 1 4.03 4.03 2.85 2.85 0 0 1-4.03-4.03" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.505 2.25H7.496A5.245 5.245 0 0 0 2.25 7.496v9.008a5.245 5.245 0 0 0 5.246 5.246h9.008a5.245 5.245 0 0 0 5.246-5.245V7.496a5.245 5.245 0 0 0-5.245-5.246m.585 5.93a1.09 1.09 0 1 0 0-2.18 1.09 1.09 0 0 0 0 2.18m-8.166.744a4.35 4.35 0 1 1 6.152 6.152 4.35 4.35 0 0 1-6.152-6.152",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }